import { createFileRoute, redirect } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { Permission } from '@/lib/permissions'
import { vmcTechnicalQuery } from '@/queries/vmc-technical.query'

// Configuration des étages du synoptique VMC, sur sa propre page plutôt qu'en onglet : la vue technique
// se consulte, la configuration s'édite — deux usages, deux écrans, comme pour la chaufferie.
//
// La garde double celle de l'API (PUT /vmc/configuration répond 403 sans le rôle) : le front évite ici
// d'afficher un formulaire dont l'enregistrement échouerait.
export const Route = createFileRoute('/_dashboard/site/$id/vmc/technical/manage/')({
  beforeLoad({ context }) {
    if (!context.user?.hasPermission(Permission.VMC_CONFIGURATION)) {
      throw redirect({ to: '/403' })
    }
  },
  loader({ context, params }) {
    return context.queryClient.ensureQueryData(vmcTechnicalQuery(Number(params.id)))
  },
  pendingComponent: PendingComponent,
})
